module.exports = __webpack_public_path__ + "img/how-to-play-outer-bubble.92f3f179.png";